import React, { useState } from 'react'
import {
  FareTableDispatchContext,
  FareTableStateContext
} from '../contexts/fareTableData'
import Layout from '../components/layout'
import FareTable from '../components/fareTable/fareTable'

const CheapFlightsPage = () => {
  const [fareTableData, setFareTableData] = useState([])
  return (
    <FareTableDispatchContext.Provider value={setFareTableData}>
      <FareTableStateContext.Provider value={fareTableData}>
        <Layout fareDataForTop={fareTableData[0]}>
          <FareTable mainCityName={fareTableData[0]} />
        </Layout>
      </FareTableStateContext.Provider>
    </FareTableDispatchContext.Provider>
  )
}

export default CheapFlightsPage
